import CheckedSvg from '../../../assets/images/checked.svg';
import SummarySvg from '../../../assets/images/summary.svg';
import DocumentSvg from '../../../assets/images/document.svg';
import DomainSvg from '../../../assets/images/domain.svg';
import ProfileSvg from '../../../assets/images/profile.svg';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { GetQueryParams } from '../../../helpers/getUrlParams';

export const SuccessStep = () =>{
    const { t } = useTranslation();

    return(
        <nav aria-label="breadcrumb">
            <ol className="d-flex breadcrumb col-xl-12 mx-auto">
                <li className="active"><a href="/#" className="disabled"><span className="circle"><img src={ProfileSvg} width="30px" alt=''/></span>1. {t('ProfileText')}</a></li>
                <li className="active"><a href="/#" className="disabled"><span className="circle"><img src={DocumentSvg} width="30px" alt=''/></span>2. {t('DocumentText')}</a></li>
                <li className="active"><a href="/#" className="disabled"><span className="circle"><img src={DomainSvg} width="30px" alt=''/></span>3. {t('DomainInformationText')}</a></li>
                <li className="active"><a href="/#" className="disabled"><span className="circle"><img src={SummarySvg} width="30px" alt=''/></span>4. {t('SummaryText')}</a></li>
            </ol>
        </nav> 

    )
}